import { render } from "./SystemSettingComponents.vue?vue&type=template&id=1d517f20"
import script from "./SystemSettingComponents.vue?vue&type=script&lang=js"
export * from "./SystemSettingComponents.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/h5/common/basedata/setting/SystemSettingComponents.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1d517f20"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1d517f20', __exports__)) {
    api.reload('1d517f20', __exports__)
  }
  
  module.hot.accept("./SystemSettingComponents.vue?vue&type=template&id=1d517f20", () => {
    api.rerender('1d517f20', render)
  })

}


export default __exports__